import React, { Component } from 'react'

export class MenuButtonContainer extends Component {
  render() {
    return (
      <button
        className={`menu__button hamburger hamburger--spin ${this.props.isMenuOpen
          ? 'is-active'
          : ''}`}
        type="button"
        onClick={() => this.props.toggleMenu()}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/menuButton.container.js